/**
 * 案例模板常量
 * 用于在添加自定义模板弹窗中展示参考案例
 */

export const EXAMPLE_TEMPLATES = {
  ENTERPRISE_RESEARCH: {
    title: "XXX企业访谈框架",
    info: `XXX企业访谈框架
   1、公司概况与历史沿革
   2、商业模式与产品
   3、市场分析
   4、核心壁垒
   5、竞争对比
   6、客户订单进展
   7、未来发展战略
   8、财务与融资`
  },

  PRODUCT_EVALUATION: {
    title: "XXX行业调研框架",
    info: `一、行业基本盘与驱动力
   1.行业定义与边界
   2.发展历程与关键驱动
   3.当前格局形成原因
   二、当下现状
   1.行业共识与误区
   2.关键瓶颈
   3.主要玩家画像
   三、未来推演
   1.短期趋势
   2.关键拐点判断
   3.投资机会`
  },

  PROJECT_REVIEW: {
    title: "XXX市场需求分析框架",
    info: `一、市场全景分析
   1.市场界定与容量
   2.核心动因与瓶颈
   二、用户与需求洞察
   1.用户画像与核心痛点
   2.决策场景与流程
   三、竞争格局评估
   1.竞争者与替代方案
   2.竞争焦点与空白
   四、需求趋势研判
   1.需求验证与演变
   2.未来需求猜想
   五、战略结论与建议
   1.核心发现与匹配建议
   2.关键风险提示`
  }
} as const;

// 默认展示的案例模板（可以根据需要调整）
export const DEFAULT_EXAMPLE_TEMPLATE = EXAMPLE_TEMPLATES.ENTERPRISE_RESEARCH;

// 案例模板数组，便于切换
export const EXAMPLE_TEMPLATES_LIST = [
  EXAMPLE_TEMPLATES.ENTERPRISE_RESEARCH,
  EXAMPLE_TEMPLATES.PRODUCT_EVALUATION,
  EXAMPLE_TEMPLATES.PROJECT_REVIEW
] as const;

